export default __webpack_public_path__ + "static/media/cases3.cdaf27d5.jpg";